module.exports = __webpack_public_path__ + "static/media/issue8.af403a17.webp";